import { useFormContext } from "react-hook-form";
import { useEffect, useRef, useState } from "react";
import { Link } from "@mui/material";

const Index = () => {
  const { watch } = useFormContext();
  const datoteka = watch("uploadXmlFile.xmlDatotekaAttachment");
  const linkRef = useRef<HTMLAnchorElement>(null);
  const [url, setUrl] = useState("");

  useEffect(() => {
    if (!datoteka || linkRef.current === null) return;
    linkRef.current.download = "Rezultat predvalidacije.xml";
    setUrl(`data:application/xml;base64,${datoteka}`);
  }, [datoteka, linkRef]);

  return (
    <>
      <Link href={url} ref={linkRef}>
        Preuzmi (Download)
      </Link>
    </>
  );
};

export default Index;
